import React from "react";
import styles from "./styles.module.scss";
import { currentEnv } from "~/configs";

const ManagePaymentMethodPage = ({}) => {
  return (
    <div className={styles.page}>
      <iframe
        className={styles.iframe}
        loading={"eager"}
        src={`${currentEnv.BO_WEB}/payment-method?noLayout=true`}
      />
    </div>
  );
};

export default ManagePaymentMethodPage;
